import { FC, memo, useLayoutEffect } from 'react';

import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';
import BrowserUtils from '@zvuk-b2b/react-uikit/toolkit/BrowserUtils';

import { TEXTS } from './texts';
import styles from './index.module.scss';

const YANDEX_BROWSER_URL = 'https://browser.yandex.ru/';
const MINTSIFRY_CERTS_URL = 'https://www.gosuslugi.ru/crt';

const SberRedirectWarningModal: FC<ModalProps[ModalTypes.SBER_REDIRECT_WARNING]> = ({ onConfirm, close }) => {
  const handleConfirm = () => {
    close();
    onConfirm();
  };

  useLayoutEffect(() => {
    if (BrowserUtils.isYandexBrowser) {
      close();
      onConfirm();
    }
  }, [close, onConfirm]);

  return (
    <ModalScreen
      title={TEXTS.TITLE}
      onClose={close}
      contentClassName={styles.content}
      actionButtons={[
        <Button
          elementId="button_sber_warning_confirm"
          key="button_sber_warning_confirm"
          type={ButtonType.PRIMARY}
          onClick={handleConfirm}>
          {TEXTS.CONFIRM}
        </Button>,
      ]}>
      <div>{TEXTS.INTRO}</div>
      <div>{TEXTS.CHOOSE_VARIANT}</div>
      <div className={styles.variant}>
        <strong>{TEXTS.VARIANT_1_TITLE}</strong>
        <ul>
          <li>
            {TEXTS.VARIANT_1_ITEM_1_BEFORE}
            <a
              href={YANDEX_BROWSER_URL}
              target="_blank"
              rel="noreferrer">
              {TEXTS.VARIANT_1_ITEM_1_LINK}
            </a>
            {TEXTS.VARIANT_1_ITEM_1_AFTER}
          </li>
          <li>{TEXTS.VARIANT_1_ITEM_2}</li>
        </ul>
      </div>
      <div className={styles.variant}>
        <strong>{TEXTS.VARIANT_2_TITLE}</strong>
        <ul>
          <li>
            {TEXTS.VARIANT_2_ITEM_1_BEFORE}
            <a
              href={MINTSIFRY_CERTS_URL}
              target="_blank"
              rel="noreferrer">
              {TEXTS.VARIANT_2_ITEM_1_LINK}
            </a>
            {TEXTS.VARIANT_2_ITEM_1_AFTER}
          </li>
          <li>{TEXTS.VARIANT_2_ITEM_2}</li>
        </ul>
      </div>
    </ModalScreen>
  );
};

export default memo(SberRedirectWarningModal);
